import * as $ from 'jquery';
import 'jquery-colorbox';

export default function init() {
	const loadLazy = (img: any) => {
		let $img = $(img);

		$img.attr("src", $img.attr("data-src"));
		$img.attr("srcset", $img.attr("data-srcset"));
		$img.addClass('stop-it');

		$img.removeAttr("data-src");
		$img.removeAttr("data-srcset");
		$img.removeClass('lazy');
	}

	// TODO: account for multiple galleries on one page
	const jqueryElements = $('.grids-area .wp-block-cover, .grids-area .wp-block-image:only-child');
	if ((jqueryElements as any).colorbox !== undefined) {
		(jqueryElements as any).colorbox({
			//rel: 'gal',
			inline: true,
			href: function() {
				return $(this).find('img').clone(); // cloning prevents image on page from being hidden when lightbox is open
			},
			transition: 'elastic',
			initialWidth: '200',
			initialHeight: '200',
			maxWidth: '1600',
			width: '100%',
			height: '100%',
			//maxHeight: '99%',
			fixed: true,
			reposition: true,
			close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17.33 16.84">\
				<path fill="#fff" d="M13.46 15.34l1.48-1.49 15.35 15.34-1.49 1.49z" transform="translate(-12.96 -13.85)"/>\
				<path fill="#fff" d="M13 29.2l15.31-15.34 1.48 1.48-15.34 15.35z" transform="translate(-12.96 -13.85)"/>\
			</svg><span>Close</span>',
			previous: '\
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 332.57 570.29">\
					<path fill="#fff" d="M332.57 47.43a19.69 19.69 0 01-5.72 13.14L102.28 285.14l224.57 224.57a18 18 0 010 26.29l-28.57 28.57a18 18 0 01-26.28 0L5.71 298.29a18 18 0 010-26.29L272 5.71a18 18 0 0126.28 0l28.57 28.57a18.61 18.61 0 015.72 13.15z"/>\
				</svg>\
				<span>prev</span>',
			next: '\
				<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 332.57 570.28">\
					<path fill="#fff" d="M332.57 285.14a19.75 19.75 0 01-5.71 13.15L60.57 564.57a19.69 19.69 0 01-13.14 5.72 19.71 19.71 0 01-13.15-5.72L5.71 536A18.59 18.59 0 010 522.86a19.72 19.72 0 015.71-13.14l224.57-224.57L5.71 60.57a18 18 0 010-26.28L34.28 5.72A19.71 19.71 0 0147.43 0a19.69 19.69 0 0113.14 5.72L326.86 272a19.73 19.73 0 015.71 13.15z" />\
				</svg>\
				<span>next</span>',
			onOpen: () => {
				document.querySelector('html').classList.add('lockScroll');
			},
			/* onComplete: () => {
				// NOTE: This was needed due to T3 Cache plugin on Kona. Was really screwing up height on this site.


				// Images may not be loaded and when when listening for them to be loaded, calling resize() still doesn't
				// always work, so we have to fallback to using a setInterval to be safe and ensure everything works.

				// Resize once now
				//@ts-ignore
				$.colorbox.resize();

				// and start interval to refresh every second until lightbox is closed
				if (resizeInterval !== undefined) {
					clearInterval(resizeInterval);
				}
				//@ts-ignore
				setTimeout(() => $.colorbox.resize(), 200);
				//@ts-ignore
				setTimeout(() => $.colorbox.resize(), 500);
				//@ts-ignore
				resizeInterval = setInterval(() => $.colorbox.resize(), 1000);
			}, */
			onClosed: () => {
				document.querySelector('html').classList.remove('lockScroll');

				// Stop interval
				/* clearInterval(resizeInterval);
				resizeInterval = undefined; */
			}
		});
	}
}
